export default "__VITE_ASSET__BMDrAivu__"